// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UngroupOutlinedSvg from "@ant-design/icons-svg/es/asn/UngroupOutlined";
import AntdIcon from '../components/AntdIcon';

var UngroupOutlined = function UngroupOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UngroupOutlinedSvg
  }));
};

UngroupOutlined.displayName = 'UngroupOutlined';
export default React.forwardRef(UngroupOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UngroupOutlined.js
// module id = 1975
// module chunks = 0